// mapper that help maps query to skill taxonomy 2.0 skillName
const browseInSerpQueryMapper: Record<string, string> = {
  '.net': '.NET Framework',
  '3d': '3D Modeling',
  agile: 'Agile Methodology',
  ai: 'Artificial Intelligence',
  algorithm: 'Algorithms',
  amazon: 'Amazon Web Services',
  android: 'Android Development',
  animation: 'Animation and Game Design', // ? api doesn't return
  architecture: 'Architectural Design',
  aws: 'Amazon Web Services',
  azure: 'Microsoft Azure',
  backend: 'Back-End Web Development',
  biotechnology: 'Bioinformatics', // ? a bit different but close
  blockchain: 'Blockchain',
  'business analyst': 'Business Analysis',
  c: 'C (Programming Language)',
  'c programming': 'C (Programming Language)',
  'c#': 'C# (Programming Language)',
  'c++': 'C++ (Programming Language)',
  cad: 'AutoCAD',
  canva: 'Canva (Software)',
  // cfa: 'Financial Analysis', // ? description not so relevant
  'chat gpt': 'ChatGPT',
  chatgpt: 'ChatGPT',
  'civil engineering': 'Civil and Architectural Engineering',
  cloud: 'Cloud Computing',
  coding: 'Computer Programming',
  computer: 'Computer Hardware',
  'computer science': 'Computer Science',
  construction: 'Construction Management',
  'content writing': 'Copywriting',
  crypto: 'Cryptography', // ? could actually mean cryptocurrency but no skills for that
  cyber: 'Cybersecurity',
  'cyber security': 'Cybersecurity',
  'data analyst': 'Data Analysis', // ? job title -> skill
  'data analytics': 'Data Analysis', // ? broad to specific
  'data scientist': 'Data Science', // ? job title -> field name
  database: 'Databases',
  django: 'Django (Web Framework)',
  docker: 'Docker (Software)',
  ecommerce: 'E-Commerce',
  education: 'Education and Training',
  electronics: 'Electronic Hardware',
  energy: 'Energy and Utilities',
  exce: 'Microsoft Excel',
  excel: 'Microsoft Excel',
  figma: 'Figma (Design Software)',
  'finance courses': 'Finance',
  financial: 'Finance',
  'financial market': 'Financial Markets',
  'financial modelling': 'Financial Modeling',
  flutter: 'Flutter (Software)',
  food: 'Food and Beverage',
  forex: 'Financial Trading',
  'forex trading': 'Financial Trading',
  front: 'Front-End Web Development',
  'front end': 'Front-End Web Development',
  'front-end developer': 'Front-End Web Development',
  frontend: 'Front-End Web Development',
  'full stack': 'Full-Stack Web Development',
  'full stack development': 'Full-Stack Web Development',
  'full stack web development': 'Full-Stack Web Development',
  'game development': 'Video Game Development', // ? api doesn't return
  gis: 'Geographic Information Systems',
  git: 'Git (Version Control System)',
  golang: 'Go (Programming Language)',
  'google cloud': 'Google Cloud Platform',
  health: 'Health Care',
  hr: 'Human Resources',
  html: 'HTML and CSS',
  'human resource': 'Human Resources',
  'human resource management': 'Human Resources Management and Planning',
  'introduction to artificial intelligence (ai)': 'Artificial Intelligence',
  investment: 'Investment Management',
  iot: 'Internet of Things',
  it: 'Information Technology',
  'it support': 'Information Technology', // ? specific to broad
  jira: 'Jira (Software)',
  language: 'Language Learning',
  law: 'Law, Regulation, and Compliance',
  'marketing digital': 'Digital Marketing',
  math: 'Mathematics and Mathematical Modeling',
  mathematics: 'Mathematics and Mathematical Modeling',
  medical: 'Medical Science and Research',
  'medical coding': 'Medical Billing and Coding', // ? api doesn't return
  medicine: 'General Medicine',
  ml: 'Machine Learning',
  'ms excel': 'Microsoft Excel',
  network: 'Computer Networking',
  networking: 'Computer Networking',
  neurosciences: 'Neurology',
  nlp: 'Natural Language Processing',
  nutrition: 'Nutrition and Diet', // ? api doesn't return
  oracle: 'Oracle Databases',
  photoshop: 'Adobe Photoshop',
  php: 'PHP (Scripting Language)',
  phyton: 'Python Programming',
  plc: 'Programmable Logic Controllers', // ? api doesn't return
  pmp: 'Project Management',
  powerbi: 'Power BI',
  product: 'Product Management',
  'product manager': 'Product Management',
  programming: 'Computer Programming',
  'project manager': 'Project Management',
  py: 'Python Programming',
  pyth: 'Python Programming',
  python: 'Python Programming',
  'python for beginners': 'Python Programming',
  pytorch: 'PyTorch',
  quality: 'Quality Assurance and Control', // ? broad to specific
  quickbooks: 'QuickBooks (Accounting Software)',
  r: 'R Programming',
  react: 'React.js',
  'react js': 'React.js',
  revit: 'Autodesk Revit',
  sap: 'SAP Applications',
  scrum: 'Scrum (Software Development)',
  security: 'Cybersecurity', // ? broad to specific
  'six sigma': 'Six Sigma Methodology',
  software: 'Software Development',
  'software testing': 'Software Quality Assurance',
  solidworks: 'SolidWorks (CAD)',
  'stock market': 'Financial Trading',
  'stock trading': 'Financial Trading',
  'supply chain': 'Supply Chain Management',
  tableau: 'Tableau Software',
  // tesol: 'Teaching English to Speakers of Other Languages (TESOL)', // no skills for this but top 500
  ui: 'User Interface (UI)',
  'ui ux': 'User Interface and User Experience (UI/UX) Design',
  unity: 'Unity Engine', // ? api doesn't return
  ux: 'User Experience Design',
  'ux design': 'User Experience Design',
  vba: 'Visual Basic (Programming Language)',
  video: 'Video Production', // or Videography ? api doesn't return anyways
  web: 'Web Development',
};
export default browseInSerpQueryMapper;
